// Configuración de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  SOLICITAR_CAMBIO_CONTRASENA: `${API_BASE_URL}/auth/solicitar-cambio-contrasena`,
  CONFIRMAR_CAMBIO_CONTRASENA: `${API_BASE_URL}/auth/confirmar-cambio-contrasena`,
  CAMBIAR_CONTRASENA: `${API_BASE_URL}/auth/cambiar-contrasena`,
  RECOVERY_PASSWORD: `${API_BASE_URL}/auth/recovery-password`,
  SOCIOS: `${API_BASE_URL}/socios`,
  HISTORIAL: `${API_BASE_URL}/historial`,
  DOCUMENTOS: `${API_BASE_URL}/documentos`,
};

export default API_BASE_URL; 